// extracted by mini-css-extract-plugin
export default {"wrap":"quote_wrap__-HcFR","speaker":"quote_speaker__re-35","quote":"quote_quote__9Vnsn"};